class LocalStorageHelper {
  constructor() {
    this.storage = window.localStorage

    // Bind context to be able to use all methods in callbacks that overrides 'this'
    this.get = this.get.bind(this)
    this.set = this.set.bind(this)
    this.remove = this.remove.bind(this)
  }

  get(key) {
    if (key) {
      const storedData = this.storage.getItem(key)
      try {
        return JSON.parse(storedData)
      } catch (err) {
        return storedData
      }
    } else {
      throw new Error(`Missing key name to remove local storage item!`)
    }
  }

  set(key, data) {
    if (key && data) {
      this.storage.setItem(key, JSON.stringify(data))
    } else {
      throw new Error(`Missing arguments to save in local storage!`)
    }
  }

  remove(key) {
    if (key) {
      this.storage.removeItem(key)
    } else {
      throw new Error(`Missing key name to remove local storage item!`)
    }
  }
}
export default new LocalStorageHelper()
